<template>
  <svg id="icon-manual" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-414.5-12.5h554v512h-554z"/>
      <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5.5 14.344c0-.777.63-1.406 1.406-1.406H14.5"/>
        <path d="M6.906 4.5H14.5v11.25H6.906c-.776 0-1.406-.63-1.406-1.406V5.906c0-.776.63-1.406 1.406-1.406z"/>
      </g>
    </g>
  </svg>
</template>
